import { ChordLib } from '@tunasong/music-lib'
import type { Chord } from '@tunasong/music-lib'
import type { FC } from 'react'
import styles from './reharm-slot.module.css'

export interface ReharmSlotProps {
  chord: Chord
  index: number
  romanLabel: string
  selected: boolean
  /** Visual highlight when this slot is part of an active substitution. */
  active: boolean
  onClick: (index: number) => void
}

/**
 * One progression-strip slot. Renders chord name + roman-numeral label +
 * 1-indexed slot number. Real `<button>` for keyboard reachability; uses
 * `aria-pressed` to indicate which slot is currently selected.
 */
export const ReharmSlot: FC<ReharmSlotProps> = props => {
  const { chord, index, romanLabel, selected, active, onClick } = props
  const className = [styles.slot, selected ? styles.selected : '', active ? styles.active : '']
    .filter(Boolean)
    .join(' ')
  return (
    <button type="button" className={className} aria-pressed={selected} onClick={() => onClick(index)}>
      <span className={styles.chordName}>{ChordLib.getName(chord)}</span>
      <span className={styles.roman}>{romanLabel}</span>
      <span className={styles.index}>{index + 1}</span>
    </button>
  )
}
